<template>
  <v-app-bar clipped-left app color="secondary" dark>
    <v-app-bar-nav-icon v-if="showSideIcon" @click.stop="$emit('input', !value)" />
    <v-toolbar-title v-if="home" @click="home">{{ title }}</v-toolbar-title>
    <v-toolbar-title v-else>{{ title }}</v-toolbar-title>
    <v-spacer />
    <slot />
    <v-menu v-if="logged" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn color="secondary darken-1" depressed v-on="on">
          <v-icon class="mr-1">account_circle</v-icon> {{ username }} <v-icon>expand_more</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="item in profile" :key="item.title" @click="item.action">
          <v-list-item-title> <v-icon>{{ item.icon }}</v-icon> {{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>

export default {
  props : {
    title: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    profile: {
      type: Array,
      default: () => []
    },
    logged: {
      type: Boolean,
      default: false
    },
    home: {
      type: Function,
      default: () => ''
    },
    showSideIcon: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    // TODO: quitar en proximo breaking change
    value(val) {
      this.$emit('drawer', val);
    },
  }
};
</script>
